(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cherry-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCollection(root) {
      var forms = root.querySelectorAll('.cherry-coll__toolbar');
      forms.forEach(function (form) {
        if (form.dataset.cherryReady) return;
        form.dataset.cherryReady = 'true';

        // Auto-submit on sort change
        var sort = form.querySelector('[data-cherry-sort]');
        if (sort) {
          sort.addEventListener('change', function () {
            form.requestSubmit ? form.requestSubmit() : form.submit();
          });
        }

        // Close the filter drawer when clicking outside
        var details = form.querySelector('.cherry-coll__filters');
        if (details) {
          document.addEventListener('click', function (e) {
            if (details.open && !details.contains(e.target)) {
              details.open = false;
            }
          });
        }
      });
    }

    initCollection(document);
    document.addEventListener('shopify:section:load', function (e) {
      initCollection(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cherry-delivery"] && !Shopify.designMode) return;
  try {
    
  function cherryDeliveryInit(scope) {
    (scope || document).querySelectorAll('.cherry-delivery').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var input = root.querySelector('.cherry-delivery__input');
      var btn = root.querySelector('.cherry-delivery__btn');
      var msg = root.querySelector('.cherry-delivery__msg');
      var van = root.querySelector('.cherry-delivery__van');
      if (!input || !btn || !msg) return;
      var codes = (root.dataset.postcodes || '').split(/[\s,;]+/).filter(Boolean);
      function check() {
        var v = (input.value || '').trim();
        msg.classList.remove('is-ok', 'is-warn');
        if (!/^\d{4}$/.test(v)) {
          msg.textContent = root.dataset.msgInvalid;
          msg.classList.add('is-warn');
          return;
        }
        if (codes.indexOf(v) > -1) {
          msg.textContent = root.dataset.msgSuccess;
          msg.classList.add('is-ok');
          if (van) {
            van.classList.remove('is-driving');
            void van.offsetWidth;
            van.classList.add('is-driving');
          }
        } else {
          msg.textContent = root.dataset.msgOutside;
          msg.classList.add('is-warn');
        }
      }
      btn.addEventListener('click', check);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          check();
        }
      });
    });
  }
  cherryDeliveryInit(document);
  document.addEventListener('shopify:section:load', function (e) {
    cherryDeliveryInit(e.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cherry-event-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-et]').forEach(function (form) {
        if (form.dataset.etReady) return;
        form.dataset.etReady = '1';
        var idInput = form.querySelector('[data-et-id]');
        var priceEl = form.querySelector('[data-et-price]');
        var btnPriceEl = form.querySelector('[data-et-btnprice]');
        var qty = form.querySelector('[data-et-qty]');

        form.querySelectorAll('[data-et-session]').forEach(function (btn) {
          if (btn.disabled) return;
          btn.addEventListener('click', function () {
            form.querySelectorAll('[data-et-session]').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            if (idInput) idInput.value = btn.dataset.vid;
            if (priceEl) priceEl.textContent = btn.dataset.price;
            if (btnPriceEl) btnPriceEl.textContent = btn.dataset.price;
          });
        });

        var minus = form.querySelector('[data-et-minus]');
        var plus = form.querySelector('[data-et-plus]');
        if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
        if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cherry-taste"] && !Shopify.designMode) return;
  try {
    
  function cherryTasteInit(scope) {
    (scope || document).querySelectorAll('[data-cherry-taste]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-taste-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-taste-panel]'));
      var underline = root.querySelector('[data-taste-underline]');
      if (!tabs.length) return;
      function moveUnderline(btn) {
        if (underline && btn) {
          underline.style.left = btn.offsetLeft + 'px';
          underline.style.width = btn.offsetWidth + 'px';
        }
      }
      var active = 0;
      function activate(i) {
        active = i;
        tabs.forEach(function (t, idx) { t.setAttribute('aria-selected', idx === i ? 'true' : 'false'); });
        panels.forEach(function (p, idx) {
          if (idx === i) { p.classList.add('is-active'); p.removeAttribute('aria-hidden'); }
          else { p.classList.remove('is-active'); p.setAttribute('aria-hidden', 'true'); }
        });
        moveUnderline(tabs[i]);
      }
      tabs.forEach(function (t, idx) { t.addEventListener('click', function () { activate(idx); }); });
      activate(0);
      requestAnimationFrame(function () { moveUnderline(tabs[0]); });
      setTimeout(function () { moveUnderline(tabs[active]); }, 500);
      window.addEventListener('resize', function () { moveUnderline(tabs[active]); }, { passive: true });
    });
  }
  cherryTasteInit(document);
  document.addEventListener('shopify:section:load', function (e) { cherryTasteInit(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
